import { render, staticRenderFns } from "./RespSafeReg.vue?vue&type=template&id=0b0cab1f&scoped=true"
import script from "./RespSafeReg.vue?vue&type=script&lang=js"
export * from "./RespSafeReg.vue?vue&type=script&lang=js"
import style0 from "./RespSafeReg.vue?vue&type=style&index=0&id=0b0cab1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0cab1f",
  null
  
)

export default component.exports